import { render, staticRenderFns } from "./cost-files-table.vue?vue&type=template&id=1860c85e&scoped=true"
import script from "./cost-files-table.vue?vue&type=script&lang=js"
export * from "./cost-files-table.vue?vue&type=script&lang=js"
import style0 from "./cost-files-table.vue?vue&type=style&index=0&id=1860c85e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1860c85e",
  null
  
)

export default component.exports